export default "__VITE_ASSET__CAPTSNzW__"